import { render, staticRenderFns } from "./manageData.vue?vue&type=template&id=b5173424&scoped=true"
import script from "./manageData.vue?vue&type=script&lang=js"
export * from "./manageData.vue?vue&type=script&lang=js"
import style0 from "./manageData.vue?vue&type=style&index=0&id=b5173424&prod&lang=less"
import style1 from "./manageData.vue?vue&type=style&index=1&id=b5173424&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5173424",
  null
  
)

export default component.exports